import { Navigate } from 'react-router-dom';

/** La home redirige a /tasks (la Task list e' la pagina principale) */
export function HomePage() {
  return <Navigate to="/tasks" replace />;
}
